export enum ReflectionRoleEnum {
  Teacher = 'teacher',
  Student = 'student',
  Guardian = 'guardian',
  Staff = 'staff',
  Shadow = 'shadow',
}
